import {
  IssuerCTSConfigData,
  RequestResponse,
  TokenRequestorConfigData
} from "../types";
import { axiosInstanceCTS } from "../axios";

export const addIssuerOnCTS: (
  data: IssuerCTSConfigData
) => Promise<RequestResponse> = async data => {
  try {
    await axiosInstanceCTS.post("/issuers", data);
    return { error: false, data: null };
  } catch (error) {
    console.error("Error configuring issuer on CTS: ", error);
    return {
      error: true,
      message: error?.response?.data?.errorMessage || error.message,
      data: null
    };
  }
};

export const configureTokenRequestor: (
  data: TokenRequestorConfigData
) => Promise<RequestResponse> = async data => {
  try {
    await axiosInstanceCTS.post("/issuers/token-requestor/add", data);
    return { error: false, data: null };
  } catch (error) {
    console.error("Error configuring issuer on CTS: ", error);
    return {
      error: true,
      message: error?.response?.data?.errorMessage || error.message,
      data: null
    };
  }
};
